import React, { useContext } from "react";
import { LangCtx, PayLoadCtx } from "../../../../lib/context";
import { Button } from "@material-ui/core";
import "../styles.css";
import { useHistory } from "react-router-dom";

const NoLicenses = () => {
    const { l } = useContext(LangCtx);
    const history = useHistory();
    const {payload} = useContext(PayLoadCtx);

    const handleBuyLicense = () => {
        history.push(`/place-your-order/INVCCCP/${payload?.doctorsCount ? payload?.doctorsCount : 5}?username=${payload && payload?.email}&subdomain=${payload && payload?.subdomain}`);
    }

    return (
        <div className="flexCol noLicenseBox pdngTopMD">
            <h1 className="subHndTxt">{l.buy_activate_licenses}</h1>
            <p className="paraInfoTxt">
                {l.license_puchase_or_renew_desc}!
            </p>
            <div className="flexRow pdngTopMD borderTop jcFE">
                <div className="brdrRadius primary pdngXS">
                    <Button fullWidth variant="contained" color="primary" className="whiteTxt" disableElevation size="small" onClick={handleBuyLicense}>
                        {l.buy_license}
                    </Button>
                </div>
                {/* <a href="https://www.invc.vc/pricing" target="_blank" className="brdrRadius primary pdngSM">
                    {l.buy_license}
                </a> */}
                {/* <a href="https://website.invc.in/plans-pricing-invcpro" target="_blank" className="linkFilledBtn primary Sm noMrgn">Purchase a licesne now</a> */}
            </div>
        </div>
    );
};

export default NoLicenses;
